import store from '../redux/store';
import { availableRoles } from '../config/roles';
import { normalize_roles } from './hasRole';

export const checkPermissions = (roleToCheck, userRoles) => {
    let hasAccess = false;

    if (!roleToCheck) {
        return true;
    }

    if (!userRoles) {
        userRoles = store.getState()?.user?.user?.roles ? store.getState().user.user.roles : [];
    }

    userRoles = normalize_roles(userRoles);
    const normalizedRoleToCheck = normalize_roles(roleToCheck)[0] || roleToCheck;

    userRoles.forEach((role) => {
        if (availableRoles[role] && availableRoles[role].includes(normalizedRoleToCheck)) {
            hasAccess = true;
        }
    });

    return hasAccess;
};
